<template>
  <div class="productCarousel">
    <el-carousel
      ref="carousel"
      :interval="4000"
      type="card"
      :indicator-position="'none'"
    >
      <el-carousel-item v-for="item in showList" :key="item.id" :name="item.id">
        <div class="bannerArea" @click="openSupplier">
          <div class="imgArea">
            <el-image
              @click.stop=""
              class="img"
              :src="item.fileUrl"
              fit="contain"
              :preview-src-list="fileUrlList"
            ></el-image>
          </div>
          <div class="goodsName">{{ item.fileName }}</div>
          <div class="divider">了解详情</div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div
      class="btnList"
      :style="{
        justifyContent: showList.length > 15 ? 'flex-start' : 'center',
      }"
    >
      <div
        class="listItem"
        v-for="item in showList"
        :key="item.id"
        @click="onChangeCarousel(item)"
      >
        <img :src="item.fileUrl" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    productList: {
      type: Array,
      default: () => [],
    },
    dataSource: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    fileUrlList() {
      return this.showList.map((i) => i.fileUrl);
    },
    showList() {
      return (this.productList || []).map((i) => {
        return {
          ...i
        };
      });
    },
  },
  data() {
    return {};
  },
  methods: {
    openSupplier() {
      if (!this.dataSource.relevanceBrandId) {
        this.$message.warning("敬请期待");
        return;
      }
      const url = `/premiumGoodCategoryList?brandIdList=${this.dataSource.relevanceBrandId}`;
      window.open(url, "_blank");
    },
    onChangeCarousel(res) {
      this.$refs.carousel.setActiveItem(res.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.productCarousel {
  font-family: Alibaba PuHuiTi;
  ::v-deep .el-carousel__mask {
    display: none;
  }
  ::v-deep .el-carousel__container {
    height: 254px;
  }
  .bannerArea {
    border-radius: 16px;
    background: #ffffff;
    box-sizing: border-box;
    border: 2px solid #2a54d1;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
    padding: 12px;
  }
  .imgArea {
    height: 142px;
    border-radius: 8px;
    background: #e8e8eb;
    .img {
      display: block;
      height: 142px;
      margin: 0 auto;
    }
  }
  .goodsName {
    margin-top: 18px;
    font-size: 16px;
    text-align: center;
    color: #080404;
  }
  .divider {
    width: 160px;
    margin: 16px auto 4px;
    font-size: 14px;
    text-align: center;
    color: #080404;
    opacity: 0.4;
    position: relative;
    &::before {
      content: "";
      width: 32px;
      height: 1px;
      background: #080404;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    &::after {
      content: "";
      width: 32px;
      height: 1px;
      background: #080404;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .btnList {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
    width: 1200px;
    margin-top: 24px;
  }
  .listItem {
    width: 64px;
    height: 64px;
    margin: 8px;
    padding: 4px;
    border-radius: 4px;
    background-color: #fff;
    flex-shrink: 0;
    cursor: pointer;
    transition: transform 0.3s ease;
    transform: translateZ(0);
    will-change: transform;
    backface-visibility: hidden;
    &:hover {
      transform: scale(1.05);
    }
    img {
      width: 56px;
      height: 56px;
      object-fit: contain;
    }
  }
}
</style>
